"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneObject = exports.isCloneable = void 0;
function isCloneable(object) {
    if (typeof object !== "object" || object === null) {
        return false;
    }
    return !!object.clone;
}
exports.isCloneable = isCloneable;
/**
 * Use this method to encode an object (might be an encodeable implementation) into a decodable structure
 */
function cloneObject(obj) {
    if (isCloneable(obj)) {
        return (obj).clone(); // paranthesis fix type checking for some reason?
    }
    if (Array.isArray(obj)) {
        return (obj).map((e) => {
            return cloneObject(e);
        });
    }
    if (obj instanceof Map) {
        // Transform into a normal object to conform to MapDecoders expected format
        const encodedObj = new Map();
        for (const [key, value] of obj) {
            const k = cloneObject(key);
            encodedObj.set(k, cloneObject(value));
        }
        return encodedObj;
    }
    if (obj instanceof Date) {
        return new Date(obj);
    }
    if (typeof obj === "object" && obj !== null) {
        return Object.assign(Object.create(obj.constructor.prototype), obj);
    }
    // Singular value
    return obj;
}
exports.cloneObject = cloneObject;
//# sourceMappingURL=Cloneable.js.map